export const data2_1 = [
    {
        "name": "",
        "name_code": "",
        "Jan": "1",
        "Feb": "1",
        "Mar": "1",
        "Apr": "1",
        "May": "1",
        "Jun": "1",
        "Jul": "1",
        "Aug": "1",
        "Sep": "1",
        "Oct": "1",
        "Nov": "1",
        "Dec": "1",
        "whole": "1",
        "nextJan": "1",
        "nextFeb": "1",
        "nextMar": "1",
        "nextQ1": "1",
        "sort": 0
    },
    {
        "name": "Total Rooms Available 可供出租客房数",
        "name_code": "Rooms_Available",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 1
    },
    {
        "name": "Total Rooms Occupied 实际入住客房数",
        "name_code": "Rooms_Occupied",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 2
    },
    {
        "name": "Occupancy 平均出租率",
        "name_code": "Occupancy%",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 3
    },
    {
        "name": "Average Room Rate 平均房价",
        "name_code": "Average_Room_Rate",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 4
    },
    {
        "name": "RevPAR 每间可供出租客房收入",
        "name_code": "RevPAR",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 5
    },
    {
        "name": "Rooms Revenue 客房收入",
        "name_code": "Rooms_Revenue",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 6
    },
    {
        "name": "F&B Revenue 餐饮收入",
        "name_code": "F&B_Revenue",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 7
    },
    {
        "name": "Other Operated Departments 其它营运部门收入",
        "name_code": "Others_Revenue",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 8
    },
    {
        "name": "Total Dept. Revenue 总收入",
        "name_code": "Total_Revenue",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 9
    },
    {
        "name": "Rooms Dept. Profit (Loss) 客房部门盈利（亏损）",
        "name_code": "Rooms_Dep't_Income",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 10
    },
    {
        "name": "Rooms Dept. Profit % of Dept. Rev.<br/>客房部门盈利（亏损）占部门收入百分比",
        "name_code": "Rooms_Dep't_Income_% ",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 11
    },
    {
        "name": "F&B Dept. Profit (Loss) 餐饮部门盈利（亏损）",
        "name_code": "F&B_Dep't_Income",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 12
    },
    {
        "name": "F&B Dept. Profit % of Dept. Rev.<br/>餐饮部门盈利（亏损）占部门收入百分比",
        "name_code": "F&B_Dep't_Income_% ",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 13
    },
    {
        "name": "Total Cost of Food and Beverage Sales 餐饮成本",
        "name_code": "F&B_Total_Cost",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 14
    },
    {
        "name": "Total Cost of Food and Beverage Sales % of Dept. Rev. <br/>餐饮成本占部门收入百分比",
        "name_code": "F&B_Total_Cost_%",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 15
    },
    {
        "name": "Total Dept. Labor Costs and Related Expenses <br/>所有部门总工资福利",
        "name_code": "Total_Payroll_Cost",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 16
    },
    {
        "name": "Total Dept. Labor Costs and Related Expenses % of Total Dept. Rev.<br/>所有部门总工资福利占总收入百分比",
        "name_code": "Total_Payroll_Cost_% ",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 17
    },
    {
        "name": "Utility Cost 能源成本",
        "name_code": "Utility_Cost",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 18
    },
    {
        "name": "Utility Cost % of Total Dept. Rev. 能源成本占总收入百分比",
        "name_code": "Utility_Cost_% ",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 19
    },
    {
        "name": "Other Expense and Cost 其他费用及成本",
        "name_code": "Other_Expense_and_Cost",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 20
    },
    {
        "name": "Other Expense and Cost % 其他费用及成本率",
        "name_code": "Other_Expense_and_Cost_%",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 21
    },
    {
        "name": "Gross Operating Profit (Loss) 总毛利润(亏损)",
        "name_code": "GOP",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 22
    },
    {
        "name": "GOP % of Total Rev. 总毛利润（亏损）占总收入百分比",
        "name_code": "GOP_% ",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 23
    },
    {
        "name": "Breakeven Point 盈亏平衡点",
        "name_code": "Breakeven_Point/Total_Exp",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 24
    },
    {
        "name": "Base Fee 基本管理费",
        "name_code": "Base_Fee",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 25
    },
    {
        "name": "Brand Service Fee 品牌服务费",
        "name_code": "Brand_Service_Fee",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 26
    },
    {
        "name": "Incentive Fee 奖励管理费",
        "name_code": "Incentive_Fee",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 27
    },
    {
        "name": "Total Fee 总收费",
        "name_code": "Total_Fee",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 28
    },
    {
        "name": "Complimentary Room 免费房",
        "name_code": "Complimentary_Room",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 29
    },
    {
        "name": "House Use 自用用房",
        "name_code": "House_Use",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 30
    },
    {
        "name": "O-O-O Rooms 坏房",
        "name_code": "O-O-O_Rooms",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 31
    },
    {
        "name": "O-O-S Rooms 维护房",
        "name_code": "O-O-S_Rooms",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 32
    },
    {
        "name": "Cost of Sales 销售成本",
        "name_code": "Cost of Sales 销售成本",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 33
    },
    {
        "name": "Cost of Other Operated Dept. Sales 其它营运部门成本",
        "name_code": "Cost of Other Operated Dept. Sales 其它营运部门成本",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 34
    },
    {
        "name": "Total Cost of Sales 总成本",
        "name_code": "Total Cost of Sales 总成本",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 35
    },
    {
        "name": "Operated Dept. Labor Costs and Related Expenses<br/>营运部门工资福利",
        "name_code": "Operated Dept. Labor Costs and Related Expenses 营运部门工资福利",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 36
    },
    {
        "name": "Rooms Dept. 客房部门",
        "name_code": "Rooms Dept. 客房部门",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 37
    },
    {
        "name": "F&B Dept. 餐饮部门",
        "name_code": "F&B Dept. 餐饮部门",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 38
    },
    {
        "name": "Other Operated Dept. 其它营运部门",
        "name_code": "Other Operated Dept. 其它营运部门",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 39
    },
    {
        "name": "Total Operated Dept. Labor Costs and Related Expenses<br/>营运部门总工资福利",
        "name_code": "Total Operated Dept. Labor Costs and Related Expenses 营运部门总工资福利",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 40
    },
    {
        "name": "Provision for O.E. 营运工具預提",
        "name_code": "Provision for O.E. 营运工具預提",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 41
    },
    {
        "name": "Rooms 客房",
        "name_code": "Rooms 客房",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 42
    },
    {
        "name": "Food & Beverage 餐饮",
        "name_code": "Food & Beverage 餐饮",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 43
    },
    {
        "name": "Other Operated Departments 其它营运部门",
        "name_code": "Other Operated Departments 其它营运部门",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 44
    },
    {
        "name": "Total Provision for O.E. 总营运工具預提",
        "name_code": "Total Provision for O.E. 总营运工具預提",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 45
    },
    {
        "name": "Other Expenses 其它费用",
        "name_code": "Other Expenses 其它费用",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 46
    },
    {
        "name": "Rooms 客房",
        "name_code": "Rooms 客房",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 47
    },
    {
        "name": "Food & Beverage 餐饮",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 48
    },
    {
        "name": "Other Operated Departments 其它营运部门",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 49
    },
    {
        "name": "Total Other Expenses 总其它费用",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 50
    },
    {
        "name": "Total Department Cost/Expenses 部门总成本和费用",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 51
    },
    {
        "name": "Dept. Profit (Loss) 部门盈利（亏损）",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 52
    },
    {
        "name": "Other Operated Dept. Profit (Loss) 其它部门盈利（亏损）",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 53
    },
    {
        "name": "Total Departmental Profit 总部门利润",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 54
    },
    {
        "name": "Undistributed Operating Expenses 后台部门费用",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 55
    },
    {
        "name": "Undistributed Operating Dept. <br/>Labor Costs and Related Expenses后台部门工资福利",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 56
    },
    {
        "name": "Administration & General 行政办",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 57
    },
    {
        "name": "Human Resources 人力资源部",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 58
    },
    {
        "name": "Sales & Marketing 市场销售部",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 59
    },
    {
        "name": "Property Operation & Maintenance 工程部",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 60
    },
    {
        "name": "Total Undistributed Operating Dept. Labor Costs and Related Expenses<br/>后台部门总工资福利",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 61
    },
    {
        "name": "Other Expenses 其它费用",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 62
    },
    {
        "name": "Administration & General 行政办",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 63
    },
    {
        "name": "Human Resources 人力资源部",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 64
    },
    {
        "name": "Sales & Marketing 市场销售部",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 65
    },
    {
        "name": "Property Operation & Maintenance 工程部",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 66
    },
    {
        "name": "Total Other Expenses 总其它费用",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 67
    },
    {
        "name": "Total Undistributed Operating Expenses 后台部门费用总计",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 68
    },
    {
        "name": "Profit After Undistributed Operating Expenses<br/>扣除后台部门费用总计后利润",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 69
    },
    {
        "name": "Insurance 保险",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 70
    },
    {
        "name": "Other Deductions 其它扣除",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 71
    },
    {
        "name": "Reserve for Capital Expenditure 固定资产备用",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 72
    },
    {
        "name": "Others 其它",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 73
    },
    {
        "name": "Total Other Deductions 其它扣除总计",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 74
    },
    {
        "name": "Owner's Profit(Loss) 业主利润(亏损)",
        "name_code": "",
        "Jan": "0",
        "Feb": "0",
        "Mar": "0",
        "Apr": "0",
        "May": "0",
        "Jun": "0",
        "Jul": "0",
        "Aug": "0",
        "Sep": "0",
        "Oct": "0",
        "Nov": "0",
        "Dec": "0",
        "whole": "0",
        "nextJan": "0",
        "nextFeb": "0",
        "nextMar": "0",
        "nextQ1": "0",
        "sort": 75
    }
]


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-1/data.js